export default __webpack_public_path__ + "static/media/Grazia.d507cf9d.png";